import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const fetchServiceList = createAsyncThunk(
	"fetchServiceList",
	async ({ page, limit, filters }) => {
		const params = new URLSearchParams({
			page: page ?? 1,
			size: limit ?? 20,
		});

		// NOTE: backend's GET /assets/services/all currently ignores page/size
		// and keyword search entirely (controller doesn't forward them to the
		// service layer, and there's no keyword filter implemented at all).
		// Params are still sent here so this starts working automatically
		// once that's fixed backend-side.
		if (filters?.keyword) {
			params.append("keyword", filters.keyword);
		}

		const response = await axiosHttp.get(`assets/services/all?${params}`);
		const data = response.data?.data; // { content, total, page, size }
		const docs = data?.content || [];

		// No dedicated stats endpoint exists for service records yet, so these
		// counts only reflect whatever page of records was just loaded, not
		// the full table. Ask backend for a /stats endpoint if accurate
		// counts across all pages are needed.
		const openCount = docs.filter((r) => !r.is_completed).length;
		const now = new Date();
		const completedThisMonth = docs.filter((r) => {
			if (!r.is_completed || !r.completion_date) return false;
			const d = new Date(r.completion_date);
			return (
				d.getMonth() === now.getMonth() &&
				d.getFullYear() === now.getFullYear()
			);
		}).length;

		return {
			docs,
			countCards: [
				{ name: "Open Service Records", count: openCount, color: "#faad14" },
				{
					name: "Completed This Month",
					count: completedThisMonth,
					color: "#52c41a",
				},
			],
			pagination: { page: data?.page, total: data?.total },
		};
	}
);

const ServiceListSlice = createSlice({
	name: "serviceListSlice",
	initialState: { isLoading: false, data: null, error: null, page: 1, total: 0 },
	extraReducers: (builder) => {
		builder.addCase(fetchServiceList.pending, (state) => {
			state.isLoading = true;
		});
		builder.addCase(fetchServiceList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.page = action.payload.pagination?.page;
			state.total = action.payload.pagination?.total;
		});
		builder.addCase(fetchServiceList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.error;
		});
	},
});

export default ServiceListSlice.reducer;
